import Autoplay from 'embla-carousel-autoplay';
import { classes } from 'html-classes';
import { useRef } from 'react';

import { Carousel, CarouselContent, CarouselItem } from '../Carousel/Carousel';
import type { BannerCarouselMobileProps } from '../Carousel/interfaces';

import styles from './BannerCarouselMobile.module.scss';

const BannerCarouselMobile = ({
  items,
  className,
  ...props
}: BannerCarouselMobileProps) => {
  const shouldLoop = items.length > 1;
  const isOneSlide = items.length === 1;
  const autoplay = useRef(Autoplay({ delay: 6000, stopOnInteraction: false }));

  const duplicatedItems = items.length === 2 ? [...items, ...items] : items;

  return (
    <Carousel
      {...props}
      opts={{
        loop: shouldLoop,
        align: 'center',
        active: !isOneSlide,
        slidesToScroll: 1,
      }}
      plugins={[autoplay.current]}
      className={classes([styles.carousel, className])}
    >
      <CarouselContent className={styles.carouselContent}>
        {duplicatedItems.map((item) => (
          <CarouselItem key={item.id} className={styles.slide}>
            {item.node}
          </CarouselItem>
        ))}
      </CarouselContent>
    </Carousel>
  );
};

export default BannerCarouselMobile;
